import styled from "styled-components";

export const Note = styled.p`
  grid-area: text;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
`;
